import React from 'react';

import InfiniteList from './InfiniteList';
import ListItem from './ListItem';
import NotFound from './NotFound';
import Spinner from '../common/Spinner';
import SearchBar from '../header/SearchBar';


const Wrapper = ({ children }) => (
  <div className="cont_layer">
    <div className="wrap_list">
      {children}
    </div>
  </div>
);

function Content ({
  videos, searchQuery, updateSearchQuery, isSearched,
  isFetching, closeModal, searchVideos, searchMoreVideos,
  isFetchingMore, nextPageToken, insertVideoToEditor,
}) {
  return (
    <Wrapper>
      {!isSearched
        ? renderSearchBar()
        : renderVideoList()
      }
    </Wrapper>
  );

  function renderSearchBar () {
    return (
      <div className="info_none">
        <div className="inner_info">
          <SearchBar
            searchQuery={searchQuery}
            updateSearchQuery={updateSearchQuery}
            searchVideos={searchVideos}
          />
        </div>
      </div>
    );
  }

  function renderVideoList () {
    if (isFetching) {
      return <Spinner cls="ico_loading_type1"/>;
    }

    return (videos && videos.length === 0)
      ? <NotFound />
      : <InfiniteList
        className={'list_editor2'}
        fetchMore={searchMoreVideos}
        isFetchingMore={isFetchingMore}
        spinner={<Spinner />}
        hasMore={!!nextPageToken}
      >
        {videos.map((video, index) => (
          <ListItem
            key={video.id + index}
            video={video}
            insertVideoToEditor={insertVideoToEditor}
            closeModal={closeModal}
          />
        ))}
      </InfiniteList>;
  }
}

export default Content;
